import React from "react";
import { Localize } from "components/service";
import StaffManagementFields from "../fields";
import {
    formatStaffAuditDateTime,
    getStaffAuditDevice,
    getStaffAuditSubcontractorTitle,
    getStaffAuditWorkerName,
} from "./staff-audit-log-presentation-helper";


const StaffAuditLogTableHelper = (onOpenLocation) => {
    const columns = [
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Worker</Localize>,
            dataIndex: "worker",
            className: "staff-audit-table__column--worker",
            width: 164,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Subcontractor</Localize>,
            dataIndex: "subcontractor",
            className: "staff-audit-table__column--subcontractor",
            width: 202,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_ActionType</Localize>,
            dataIndex: "action",
            className: "staff-audit-table__column--action",
            width: 127,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Result</Localize>,
            dataIndex: "result",
            className: "staff-audit-table__column--result",
            width: 123,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_DateTime</Localize>,
            dataIndex: "createdAt",
            className: "staff-audit-table__column--date-time",
            width: 172,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Reason</Localize>,
            dataIndex: "reason",
            className: "staff-audit-table__column--reason",
            width: 248,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_Device</Localize>,
            dataIndex: "device",
            className: "staff-audit-table__column--device",
            width: 146,
        },
        {
            title: <Localize>STAFF_MANAGEMENT.Column_ScanLocation</Localize>,
            dataIndex: "scanLocation",
            className: "staff-audit-table__column--scan-location",
            width: 136,
        },
    ];

    const data = (auditLogs = []) => auditLogs.map((auditLog) => {
        const auditDevice = getStaffAuditDevice(auditLog);
        const hasDevice = auditDevice.platform !== "—" || auditDevice.deviceUUID !== "—";

        return {
            key: auditLog.id,
            worker: getStaffAuditWorkerName(auditLog) || "—",
            subcontractor: getStaffAuditSubcontractorTitle(auditLog),
            action: <StaffManagementFields.AuditAction action={ auditLog.action } />,
            result: <StaffManagementFields.AuditResult status={ auditLog.status } />,
            createdAt: formatStaffAuditDateTime(auditLog.created_at),
            reason: <StaffManagementFields.AuditReason auditLog={ auditLog } />,
            device: hasDevice ? (
                <span className="d-flex flex-column staff-audit-device">
                    <span>{ auditDevice.platform }</span>
                    <span>{ auditDevice.deviceUUID }</span>
                </span>
            ) : "—",
            scanLocation: (
                <StaffManagementFields.AuditScanLocation
                    auditLog={ auditLog }
                    onOpenLocation={ onOpenLocation } />
            ),
        };
    });

    return { columns, data };
};

export default StaffAuditLogTableHelper;
